type PopupConfig = {
  slug: string;
  form: string;
  locale: 'es' | 'it' | 'fr';
};

const skuPopupConfigs: PopupConfig[] = [
  { slug: '/johnnie-walker-18-years-old-192160', form: 'WHERXn', locale: 'es' },
  { slug: '/johnnie-walker-18-years-old-192160', form: 'ResWXQ', locale: 'it' },
  { slug: '/johnnie-walker-18-years-old-192160', form: 'YiPuA3', locale: 'fr' },
  { slug: '/highland-park-valknut-viking-legend-115869', form: 'WHERXn', locale: 'es' },
  { slug: '/highland-park-valknut-viking-legend-115869', form: 'ResWXQ', locale: 'it' },
  { slug: '/highland-park-valknut-viking-legend-115869', form: 'YiPuA3', locale: 'fr' },
  { slug: '/highland-park-harald-the-warrior-series-41070', form: 'WHERXn', locale: 'es' },
  { slug: '/highland-park-harald-the-warrior-series-41070', form: 'ResWXQ', locale: 'it' },
  { slug: '/highland-park-harald-the-warrior-series-41070', form: 'YiPuA3', locale: 'fr' },
  {
    slug: '/highland-park-cask-strength-robust-intense-release-no3-217144',
    form: 'WHERXn',
    locale: 'es',
  },
  {
    slug: '/highland-park-cask-strength-robust-intense-release-no3-217144',
    form: 'ResWXQ',
    locale: 'it',
  },
  {
    slug: '/highland-park-cask-strength-robust-intense-release-no3-217144',
    form: 'YiPuA3',
    locale: 'fr',
  },
  { slug: '/glenmorangie-tsail-private-edition-58144', form: 'WHERXn', locale: 'es' },
  { slug: '/glenmorangie-tsail-private-edition-58144', form: 'ResWXQ', locale: 'it' },
  { slug: '/glenmorangie-tsail-private-edition-58144', form: 'YiPuA3', locale: 'fr' },
  {
    slug: '/glenmorangie-nectar-dor-sauternes-cask-finish-special-reserve-192090',
    form: 'WHERXn',
    locale: 'es',
  },
  {
    slug: '/glenmorangie-nectar-dor-sauternes-cask-finish-special-reserve-192090',
    form: 'ResWXQ',
    locale: 'it',
  },
  {
    slug: '/glenmorangie-nectar-dor-sauternes-cask-finish-special-reserve-192090',
    form: 'YiPuA3',
    locale: 'fr',
  },
  { slug: '/glenmorangie-a-tale-of-tokyo-limited-edition-231843', form: 'WHERXn', locale: 'es' },
  { slug: '/glenmorangie-a-tale-of-tokyo-limited-edition-231843', form: 'ResWXQ', locale: 'it' },
  { slug: '/glenmorangie-a-tale-of-tokyo-limited-edition-231843', form: 'YiPuA3', locale: 'fr' },
  { slug: '/glenmorangie-12-years-old-lasanta-second-edition-25768', form: 'WHERXn', locale: 'es' },
  { slug: '/glenmorangie-12-years-old-lasanta-second-edition-25768', form: 'ResWXQ', locale: 'it' },
  { slug: '/glenmorangie-12-years-old-lasanta-second-edition-25768', form: 'YiPuA3', locale: 'fr' },
  { slug: '/glenfiddich-project-xx-experimental-series-no-02-86461', form: 'WHERXn', locale: 'es' },
  { slug: '/glenfiddich-project-xx-experimental-series-no-02-86461', form: 'ResWXQ', locale: 'it' },
  { slug: '/glenfiddich-project-xx-experimental-series-no-02-86461', form: 'YiPuA3', locale: 'fr' },
  {
    slug: '/glenfiddich-ipa-experiment-experimental-series-no-01-86462',
    form: 'WHERXn',
    locale: 'es',
  },
  {
    slug: '/glenfiddich-ipa-experiment-experimental-series-no-01-86462',
    form: 'ResWXQ',
    locale: 'it',
  },
  {
    slug: '/glenfiddich-ipa-experiment-experimental-series-no-01-86462',
    form: 'YiPuA3',
    locale: 'fr',
  },
  { slug: '/glenallachie-8-years-old-208069', form: 'WHERXn', locale: 'es' },
  { slug: '/glenallachie-8-years-old-208069', form: 'ResWXQ', locale: 'it' },
  { slug: '/glenallachie-8-years-old-208069', form: 'YiPuA3', locale: 'fr' },
  { slug: '/dalmore-port-wood-reserve-233112', form: 'WHERXn', locale: 'es' },
  { slug: '/dalmore-port-wood-reserve-233112', form: 'ResWXQ', locale: 'it' },
  { slug: '/dalmore-port-wood-reserve-233112', form: 'YiPuA3', locale: 'fr' },
  { slug: '/caol-ila-nas-friends-of-the-classic-malts-4389', form: 'WHERXn', locale: 'es' },
  { slug: '/caol-ila-nas-friends-of-the-classic-malts-4389', form: 'ResWXQ', locale: 'it' },
  { slug: '/caol-ila-nas-friends-of-the-classic-malts-4389', form: 'YiPuA3', locale: 'fr' },
  {
    slug: '/caol-ila-10-years-old-2013-barrel-selection-wilson-and-morgan',
    form: 'WHERXn',
    locale: 'es',
  },
  {
    slug: '/caol-ila-10-years-old-2013-barrel-selection-wilson-and-morgan',
    form: 'ResWXQ',
    locale: 'it',
  },
  {
    slug: '/caol-ila-10-years-old-2013-barrel-selection-wilson-and-morgan',
    form: 'YiPuA3',
    locale: 'fr',
  },
  { slug: '/bowmore-15-years-old-12345', form: 'WHERXn', locale: 'es' },
  { slug: '/bowmore-15-years-old-12345', form: 'ResWXQ', locale: 'it' },
  { slug: '/bowmore-15-years-old-12345', form: 'YiPuA3', locale: 'fr' },
  { slug: '/bowmore-12-years-old-new', form: 'WHERXn', locale: 'es' },
  { slug: '/bowmore-12-years-old-new', form: 'ResWXQ', locale: 'it' },
  { slug: '/bowmore-12-years-old-new', form: 'YiPuA3', locale: 'fr' },
  { slug: '/ardbeg-an-oa-99885', form: 'WHERXn', locale: 'es' },
  { slug: '/ardbeg-an-oa-99885', form: 'ResWXQ', locale: 'it' },
  { slug: '/ardbeg-an-oa-99885', form: 'YiPuA3', locale: 'fr' },
  { slug: '/tomintoul-tawny-port-cask-finish-small-batch', form: 'WHERXn', locale: 'es' },
  { slug: '/tomintoul-tawny-port-cask-finish-small-batch', form: 'ResWXQ', locale: 'it' },
  { slug: '/tomintoul-tawny-port-cask-finish-small-batch', form: 'YiPuA3', locale: 'fr' },
  { slug: '/tomatin-15-years-old-red-design', form: 'WHERXn', locale: 'es' },
  { slug: '/tomatin-15-years-old-red-design', form: 'ResWXQ', locale: 'it' },
  { slug: '/tomatin-15-years-old-red-design', form: 'YiPuA3', locale: 'fr' },
  { slug: '/talisker-wilder-seas-parley-229467', form: 'WHERXn', locale: 'es' },
  { slug: '/talisker-wilder-seas-parley-229467', form: 'ResWXQ', locale: 'it' },
  { slug: '/talisker-wilder-seas-parley-229467', form: 'YiPuA3', locale: 'fr' },
  { slug: '/talisker-port-ruighe-finished-in-port-casks-40583', form: 'WHERXn', locale: 'es' },
  { slug: '/talisker-port-ruighe-finished-in-port-casks-40583', form: 'ResWXQ', locale: 'it' },
  { slug: '/talisker-port-ruighe-finished-in-port-casks-40583', form: 'YiPuA3', locale: 'fr' },
  { slug: '/laphroaig-quarter-cask-42887', form: 'WHERXn', locale: 'es' },
  { slug: '/laphroaig-quarter-cask-42887', form: 'ResWXQ', locale: 'it' },
  { slug: '/laphroaig-quarter-cask-42887', form: 'YiPuA3', locale: 'fr' },
  { slug: '/lagavulin-16-years-old-black-box-51469', form: 'WHERXn', locale: 'es' },
  { slug: '/lagavulin-16-years-old-black-box-51469', form: 'ResWXQ', locale: 'it' },
  { slug: '/lagavulin-16-years-old-black-box-51469', form: 'YiPuA3', locale: 'fr' },
  { slug: '/kilchoman-machir-bay-145242', form: 'WHERXn', locale: 'es' },
  { slug: '/kilchoman-machir-bay-145242', form: 'ResWXQ', locale: 'it' },
  { slug: '/kilchoman-machir-bay-145242', form: 'YiPuA3', locale: 'fr' },
  { slug: '/yamazaki-distillers-reserve-single-malt-whisky-201705', form: 'WHERXn', locale: 'es' },
  { slug: '/yamazaki-distillers-reserve-single-malt-whisky-201705', form: 'ResWXQ', locale: 'it' },
  { slug: '/yamazaki-distillers-reserve-single-malt-whisky-201705', form: 'YiPuA3', locale: 'fr' },
];

const klaviyoConstants = {
  skuPopupConfigs,
};

export default klaviyoConstants;
